import { ValidationRule } from '../validation.rule';
import { ValidationTypes } from '../validationtypes';

export class MaximumValidationRule extends ValidationRule {
  private maximum: number;

  constructor(maximum: number, key: string | null = null) {
    if (!key) {
      key = ValidationTypes.maximum;
    }

    super(key);
    this.maximum = maximum;
  }

  isValid(value: any): boolean {
    if (!value) {
      return true;
    }
    return +value <= this.maximum;
  }
}
